// store.js
import { configureStore } from "@reduxjs/toolkit";
import rootReducer from './reducers'; // 作成するreducers.jsをインポート

// localStorageから初期状態を取得
const storedUser = localStorage.getItem('token') ? { isAuthenticated: true } : { isAuthenticated: false };
const initialState = {
    isAuthenticated: storedUser.isAuthenticated,
    user: null,
    role: null,
    error: null,
};

const store = configureStore({
  reducer: rootReducer,
  preloadedState: initialState,
});

export default store;
